// extracted by mini-css-extract-plugin
export var rateTable = "_54-0";